import { BasePromoClient } from "../types/clients";
import { Promo } from "../types/entities";
class PromoClient extends BasePromoClient {
  async getPromos(): Promise<Promo[] | null> {
    throw new Error("getPromo not implemented");
  }

  async getPromoById(id: string): Promise<Promo | null> {
    throw new Error("getPromoById not implemented");
  }
}

export default PromoClient;
